import Image from "next/image";
import Link from "next/link";

import { Chip } from "@/components/chip/chip.component";
import type { NavigationMenuGroupItem } from "@/components/header/navigationQuery.types";

import { appendQueryString } from "@/utils/url.util";

import { urlFor } from "@/sanity/utils";

export const SiteHeaderMobileMenuFeaturedItem = ({
  item,
}: SiteHeaderMobileMenuFeaturedItemProps) => {
  if (!item.link?.url) return null;

  const imageUrl = item.image
    ? urlFor(item.image).width(200).height(160).url()
    : null;
  const chips = item.promotion?.chips?.filter(Boolean) ?? [];
  const opensInNewTab = Boolean(item.link.openInNewTab);

  return (
    <li
      className="group flex min-w-32 flex-1 justify-center"
      data-testid="site-header-mobile-menu-featured-item">
      <Link
        className="flex flex-col items-center gap-4 p-2"
        href={
          appendQueryString(item.link.url, item.link.queryString) ??
          item.link.url
        }
        target={opensInNewTab ? "_blank" : undefined}
        rel={opensInNewTab ? "noopener noreferrer" : undefined}
        data-testid="site-header-mobile-menu-featured-link">
        <div className="bg-greyscale-background relative flex h-40 max-w-50 flex-col items-center justify-center overflow-hidden rounded-xl p-4">
          {chips.length > 0 ? (
            <div
              className="absolute top-3 z-10 flex flex-row flex-wrap justify-center gap-1"
              data-testid="site-header-mobile-menu-featured-item-chips">
              {chips.map((chip) => (
                <Chip
                  key={chip._key}
                  label={chip.label ?? ""}
                  variant={chip.theme}
                  chip={chip}
                />
              ))}
            </div>
          ) : null}
          {imageUrl ? (
            <Image
              src={imageUrl}
              alt=""
              width={200}
              height={160}
              aria-hidden="true"
              className="block transition-all duration-500 group-hover:scale-110"
            />
          ) : null}
        </div>
        <span className="text-center font-bold tracking-wider">
          {item.label}
        </span>
      </Link>
    </li>
  );
};

export type SiteHeaderMobileMenuFeaturedItemProps = {
  item: FeaturedItem;
};

type FeaturedItem = NonNullable<
  NonNullable<NavigationMenuGroupItem["featuredItems"]>[number]
>;
